import { render, staticRenderFns } from "./PackageDescriptorAuthUpdate.vue?vue&type=template&id=2a9f7a25&"
import script from "./PackageDescriptorAuthUpdate.vue?vue&type=script&lang=js&"
export * from "./PackageDescriptorAuthUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports